<template>
  <IconButton
    icon="mdi-circle-edit-outline"
    :tooltip-text="$t('ChangePassword')"
    @click="redirectToChangePasswordForm"
  />
</template>

<script>
import IconButton from './IconButton.vue';

export default {
  name: 'PasswordButton',
  components: {
    IconButton
  },
  computed: {
    username() {
      return this.$store.getters.USERNAME || '';
    },
  },
  methods: {
    redirectToChangePasswordForm() {
      this.$router.push({
        path: '/login',
        query: { mode: 'reset', forced: false, login: this.username },
      });
    },
  }
};
</script>
